//TODO: Add all endpoints here

export enum ApiEndpoints {
  Tasks = "/dietitian/tasks",
  SuggestedTasks = "/dietitian/suggested-tasks",
  SuggestedTasksCount = "/dietitian/suggested-tasks-count",
  SuggestedTasksList = "/dietitian/suggested-tasks-list",
  AccountNotes = "/dietitian/account/notes",
  TasksCount = "/dietitian/number-of-tasks",
  CollectionsSearchPreview = "/dietitian/collections/search-preview",
  SearchScheduleEvents = "/dietitian/schedules/search",
  ProgramSectionCategories = "/dietitian/programs/sections/categories",
  SearchSectionsNew = "/dietitian/program-section-templates/search-new",
  SearchSection = "sectionDetails",
  UpdateSectionFavorite = "/dietitian/program-section-templates/favorite",
  UploadEducationalMaterial = "/dietitian/media/educational-material/upload",
  EducationalMaterialsLink = "/dietitian/educational-materials-link",
  EducationalMaterialsLinksSearch = "/dietitian/educational-materials-link-search",
  EducationalMaterialsLinksSearchInfinite = "/dietitian/educational-materials-link-search-infinite",
  EducationalMaterialsFilesSearchInfinite = "/dietitian/educational-materials-pdf-search-infinite",
  EducationalMaterialsTextSearchInfinite = "/dietitian/educational-materials-text-search-infinite",
  EducationalMaterialFiles = "/dietitian/educational-materials-pdf",
  EducationalMaterialFilesSearch = "/dietitian/educational-materials-pdf-search",
  PatientSharedRecipes = "/dietitian/patients/{patientId}/shared-content-recipes/search",
  PatientSharedRecipesInfinite = "/dietitian/patients/{patientId}/shared-content-recipes/search-infinite",
  PatientSharedRecipe = "/dietitian/patients/{patientId}/shared-content-recipes/{recipeId}",
  PatientSharedEducationalMaterialsUrl = "/dietitian/patients/{patientId}/shared-content-educational-materials-url-search",
  PatientSharedEducationalMaterialUrl = "/dietitian/patients/{patientId}/shared-content-educational-materials-url/{educationalMaterialId}",
  PatientSharedEducationalMaterialsText = "/dietitian/patients/{patientId}/shared-content-educational-materials-text-search",
  PatientSharedEducationalMaterialText = "/dietitian/patients/{patientId}/shared-content-educational-materials-text/{educationalMaterialId}",
  PatientSharedEducationalMaterialsPdf = "/dietitian/patients/{patientId}/shared-content-educational-materials-pdf-search",
  PatientSharedEducationalMaterialPdf = "/dietitian/patients/{patientId}/shared-content-educational-materials-pdf/{educationalMaterialId}",
  PatientSharedDiets = "/dietitian/patients/{patientId}/shared-content-diets/search",
  PatientSharedDiet = "/dietitian/patients/{patientId}/shared-content-diets/{dietId}",
  PatientSharedCollections = "/dietitian/patients/{patientId}/shared-content-collections/search",
  PatientSharedCollection = "/dietitian/patients/{patientId}/shared-content-collections/{collectionId}",
  EducationalMaterialLink = "/dietitian/educational-materials-link/{educationalMaterialId}",
  EducationalMaterialPdf = "/dietitian/educational-materials-pdf/{educationalMaterialId}",
  EducationalMaterialText = "/dietitian/educational-materials-text/{educationalMaterialId}",
  EducationalMaterialsTextSearch = "/dietitian/program-section-templates/search-new",
  PatientSharedHistory = "/dietitian/patients/{patientId}/shared-content-history",
  PatientSharedBatches = "/dietitian/job-batches/{id}",
  ActiveClients = "/dietitian/clinic/patients-new",
  DietitianSettingsStorage = "/dietitian/clinic/settings/storage",
}
